import React from 'react';
import { X, Bell, CheckCircle2, Bot, Clock, FolderKanban } from 'lucide-react';

export default function NotificationsDrawer({ activities, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-slate-900/40 backdrop-blur-xs animate-fadeIn">
      <div className="bg-white w-full max-w-md h-full shadow-2xl flex flex-col border-l border-slate-100 animate-slideLeft">
        
        {/* Header */}
        <div className="p-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
          <div className="flex items-center space-x-2">
            <Bell className="w-5 h-5 text-indigo-600" />
            <h2 className="text-lg font-bold text-slate-900">Activity Stream & Alerts</h2>
          </div>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* List */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {activities.map(act => (
            <div key={act.id} className="p-4 rounded-xl bg-slate-50 border border-slate-100 space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold text-slate-900">{act.user}</span>
                <span className="text-[10px] text-slate-400 font-mono">{act.time}</span>
              </div>
              <p className="text-xs text-slate-600">
                {act.action} <strong className="text-slate-900 font-semibold">{act.target}</strong>
              </p>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-slate-100 bg-slate-50/50 text-center">
          <button 
            onClick={onClose}
            className="w-full py-2.5 bg-slate-900 text-white rounded-xl text-xs font-semibold hover:bg-slate-800 transition"
          >
            Close Notifications
          </button>
        </div>

      </div>
    </div>
  );
}
